import useCachedFeatureFlagWithPrefs from './useCachedFeatureFlagWithPrefs'

export default function useNewMergeFlag(): ReturnType<typeof useCachedFeatureFlagWithPrefs> {
  return useCachedFeatureFlagWithPrefs('treeWeb_personR9_newMerge2', 'tree-person.newMerge2', {
    userPreferences: ['softLaunch.treeWeb_personR9_newMerge2', 'fslabs.labs'],
  })
}
